import React, { useEffect, useState } from "react";
import { codeClasses } from "@/lib/api";
import { Clock, Warning } from "@phosphor-icons/react";

/** Thresholds in minutes for the assigned code. Verde/Bianco: no alerting. */
const THRESHOLDS = { rosso: 5, arancione: 10, azzurro: 30 };

function parseTimeToday(hhmm) {
  if (!hhmm || !/^\d{1,2}:\d{2}$/.test(hhmm)) return null;
  const [h, m] = hhmm.split(":").map(Number);
  const d = new Date();
  d.setHours(h, m, 0, 0);
  return d;
}

export default function TakeoverTimer({ oraAccettazione, oraPresa, assignedCode }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (oraPresa) return; // stopped
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [oraPresa]);

  const start = parseTimeToday(oraAccettazione);
  if (!start) return null;

  const end = oraPresa ? parseTimeToday(oraPresa) : new Date(now);
  if (!end) return null;
  let elapsedMs = end.getTime() - start.getTime();
  if (elapsedMs < 0) elapsedMs += 24 * 60 * 60 * 1000; // crosses midnight
  const totalSec = Math.floor(elapsedMs / 1000);
  const mm = Math.floor(totalSec / 60);
  const ss = String(totalSec % 60).padStart(2, "0");

  const threshold = THRESHOLDS[assignedCode];
  const exceeded = threshold != null && mm >= threshold;
  const stopped = !!oraPresa;

  const bg = stopped
    ? "bg-slate-100 text-slate-700 border-slate-200"
    : exceeded
      ? "bg-red-50 text-red-800 border-red-300 animate-pulse"
      : "bg-emerald-50 text-emerald-800 border-emerald-300";

  return (
    <div
      data-testid="takeover-timer"
      data-exceeded={exceeded ? "1" : "0"}
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-md border ${bg}`}
    >
      {exceeded ? <Warning size={16} weight="fill" /> : <Clock size={16} weight="fill" />}
      <div className="text-[10px] font-semibold uppercase tracking-widest">
        {stopped ? "Presa in carico" : "Attesa presa in carico"}
      </div>
      <div className="font-mono text-lg font-semibold" data-testid="takeover-timer-value">
        {mm}:{ss}
      </div>
      {threshold != null && (
        <span className={`chip-code text-[10px] ${codeClasses(assignedCode)}`}>
          soglia {threshold}′
        </span>
      )}
    </div>
  );
}
